// extracted by mini-css-extract-plugin
export default {"scroller":"index-module__scroller--aDgVD","scroller_item":"index-module__scroller_item--j6wqJ","grid":"index-module__grid--raNV5","simplegrid":"index-module__simplegrid--Yagwo"};